// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutDeliveryMethodStyles } from "@conklin/Overrides/Widgets/OnePageCheckout/OnePageCheckoutDeliveryMethod";
import { css } from "styled-components";

onePageCheckoutDeliveryMethodStyles.servicesGridItem = {
    css: css`
        width: 100%;
    `,
};

onePageCheckoutDeliveryMethodStyles.deliveryDateGridItem = onePageCheckoutDeliveryMethodStyles.pickUpDateGridItem = {
    css: css`
        margin-top: 24px;
    `,
};

onePageCheckoutDeliveryMethodStyles.deliveryDatePicker = onePageCheckoutDeliveryMethodStyles.pickUpDatePicker = {
    cssOverrides: {
        inputSelect: css`
            width: 206px;
        `,
    },
    hintProps: {
        css: css`
            margin-top: 12px;
            display: flex;
            flex-direction: column;
            row-gap: 4px;
        `,
    },
};

onePageCheckoutDeliveryMethodStyles.recommendedShippingMethodMessage = {
    size: 14,
    lineHeight: "22px",
    css: css`
        margin-top: 16px;
        margin-bottom: 0;
        display: block;
    `,
};
